import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import {matchingPasswords, usernameValidator} from '../../theme/utils/app-validators';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ApiUrl} from "../../shared/models/apiurl.models";

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {

  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.apiUrl.getJWTToken()
    })
  }

  loginForm: FormGroup;
  registerForm: FormGroup;
  loginError: boolean = false;
  loginDescription: string = "";
  constructor(public formBuilder: FormBuilder, private apiUrl: ApiUrl, private http: HttpClient, public router:Router, public snackBar: MatSnackBar) { }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      'email': ['', Validators.compose([Validators.required, usernameValidator])],
      'password': ['', Validators.compose([Validators.required, Validators.minLength(6)])] 
    });

    this.registerForm = this.formBuilder.group({
      'name': ['', Validators.compose([Validators.required, Validators.minLength(3)])],
      'email': ['', Validators.compose([Validators.required, usernameValidator])],
      'password': ['', Validators.required],
      'confirmPassword': ['', Validators.required]
    },{validator: matchingPasswords('password', 'confirmPassword')});

  }

  public onLoginFormSubmit(values:Object):void {

    if (this.loginForm.valid) {
      const loginOpt={username: this.loginForm.value.email, password: this.loginForm.value.password}
      this.http.post<any>(this.apiUrl.loginUser(), JSON.stringify(loginOpt), this.options).subscribe(data => {
        if( data['non_field_errors'] != null){
          this.loginError = true;
        }else{
          localStorage.setItem("token", data.token)
          localStorage.setItem("userDetails", JSON.stringify(data))
          this.router.navigate([''], ).then(()=>{
            window.location.reload();
          });

        }

      },error => {

        this.loginError = true;
        this.loginDescription = 'TOBA LIGHT.label.login.error'
        this.router.navigate(['/sign-in']);
      })
      this.router.navigate(['/sign-in']);
    }
  }

  public onRegisterFormSubmit(values:Object):void {
    if (this.registerForm.valid) {
      this.snackBar.open('You registered successfully!', '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
    }
  }

}
